import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card card-body me-2 ms-2" }
const _hoisted_2 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_3 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_4 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_5 = {
  key: 0,
  class: "ms-1"
}
const _hoisted_6 = { class: "d-flex justify-content-between gap-3 flex-wrap" }
const _hoisted_7 = { class: "d-flex flex-column p-0" }
const _hoisted_8 = { class: "text-capitalize-first" }
const _hoisted_9 = {
  key: 0,
  class: "text-secondary"
}
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "text-nowrap text-capitalize-first" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "me-2"
}
const _hoisted_15 = {
  key: 1,
  class: "me-2"
}
const _hoisted_16 = {
  key: 2,
  class: "me-2"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 0,
  class: "d-flex gap-2 align-items-center ps-1"
}
const _hoisted_20 = ["onClick", "title"]
const _hoisted_21 = ["onClick", "title"]
const _hoisted_22 = { class: "invoice-input-group mt-4" }
const _hoisted_23 = { class: "input-group input-group-sm" }
const _hoisted_24 = {
  class: "input-group-text bg-white",
  id: "addon-wrapping"
}
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "mt-3" }
const _hoisted_27 = { class: "d-flex justify-content-between gap-3 flex-wrap" }
const _hoisted_28 = { class: "d-flex gap-2 align-items-center ps-1" }
const _hoisted_29 = {
  key: 0,
  class: "btn-group"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 0,
  type: "button",
  class: "btn btn-sm btn-outline-dark dropdown-toggle dropdown-toggle-split",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_32 = {
  key: 1,
  class: "dropdown-menu"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 2,
  type: "button",
  class: "btn btn-sm btn-outline-dark dropdown-toggle dropdown-toggle-split",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_38 = {
  key: 3,
  class: "dropdown-menu"
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = {
  key: 1,
  class: "btn-group"
}
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "text-end" }
const _hoisted_45 = {
  key: 0,
  class: "text-danger",
  style: {"font-size":"70%"}
}
const _hoisted_46 = {
  key: 1,
  class: "text-danger",
  style: {"font-size":"70%"}
}
const _hoisted_47 = { class: "d-flex gap-2 align-items-center justify-content-end mt-3" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "col-sm-6 d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_AccountWidget = _resolveComponent("AccountWidget")!
  const _component_MerchantStoreForm = _resolveComponent("MerchantStoreForm")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_SettingsHistoryModal = _resolveComponent("SettingsHistoryModal")!
  const _component_CrossBorderRatesModal = _resolveComponent("CrossBorderRatesModal")!
  const _component_ReferralStoreFeesModal = _resolveComponent("ReferralStoreFeesModal")!
  const _component_WithdrawalForm = _resolveComponent("WithdrawalForm")!
  const _component_AccountWalletModal = _resolveComponent("AccountWalletModal")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_WithdrawalWhitelistModal = _resolveComponent("WithdrawalWhitelistModal")!
  const _component_AutoWithdrawalSettingsModal = _resolveComponent("AutoWithdrawalSettingsModal")!
  const _component_AutoTransferSettingsModal = _resolveComponent("AutoTransferSettingsModal")!
  const _component_MerchantTransferModal = _resolveComponent("MerchantTransferModal")!
  const _component_BalanceCorrectionModal = _resolveComponent("BalanceCorrectionModal")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "dashboardLoader",
    class: "h-100 row"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stores, (store) => {
        return (_openBlock(), _createElementBlock("div", {
          key: store.id,
          class: "col-sm-6"
        }, [
          _createElementVNode("div", _hoisted_1, [
            (!store.isActive)
              ? (_openBlock(), _createElementBlock("small", _hoisted_2, [
                  _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.store_not_active')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isAdmin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(store.payInRequestLimits, (limit, option) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (limit < 1)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_4, [
                            _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
                            (option !== 'any')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.helper.trans(`payment_options.${option}`)) + ": ", 1))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.payInRequestLimitPercentWarning', {percent: _ctx.numberFormatter.formatNumber(_ctx.helper.floatToPercent(limit), 0)})), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 256))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.isAdmin)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _withDirectives((_openBlock(), _createElementBlock("small", {
                          title: store.id
                        }, [
                          _createTextVNode(_toDisplayString(store.id), 1)
                        ], 8, _hoisted_10)), [
                          [
                            _directive_b_tooltip,
                            void 0,
                            void 0,
                            { hover: true }
                          ]
                        ]),
                        _cache[15] || (_cache[15] = _createTextVNode()),
                        _createVNode(_component_copy_button, {
                          value: store.id
                        }, null, 8, ["value"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    _createElementVNode("strong", _hoisted_11, _toDisplayString(store.name) + " (" + _toDisplayString(store.currency) + ")", 1),
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(store.trafficGroups, (group) => {
                            return (_openBlock(), _createElementBlock("small", {
                              key: group.id,
                              class: "badge bg-dark text-light ms-2"
                            }, [
                              _createTextVNode(_toDisplayString(group._trafficGroup?.type) + ": " + _toDisplayString(group._trafficGroup?.name) + " ", 1),
                              (group._trafficGroup?.publicName)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, " (" + _toDisplayString(group._trafficGroup?.publicName) + ") ", 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", null, [
                  (_ctx.isAdmin && store.isPayInBlocked)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, _cache[16] || (_cache[16] = [
                        _createTextVNode("in: "),
                        _createElementVNode("i", { class: "fa fa-circle-pause text-warning" }, null, -1)
                      ])))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin && store.isPayOutBlocked)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _cache[17] || (_cache[17] = [
                        _createTextVNode("out: "),
                        _createElementVNode("i", { class: "fa fa-circle-pause text-warning" }, null, -1)
                      ])))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin && !store.isWebhooksEnabled)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _cache[18] || (_cache[18] = [
                        _createTextVNode("webhook: "),
                        _createElementVNode("i", { class: "fa fa-circle-pause text-warning" }, null, -1)
                      ])))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("small", null, _toDisplayString(_ctx.helper.trans("labels.service_fee")) + ": " + _toDisplayString(_ctx.numberFormatter.formatNumber(store.payInFee * 100, 2)) + "% / " + _toDisplayString(_ctx.numberFormatter.formatNumber(store.payOutFee * 100, 2)) + "%", 1),
                (_ctx.isAdmin && store.payInRateSource)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_17, "in: " + _toDisplayString(_ctx.helper.trans(`rate_sources.${store.payInRateSource}`)), 1))
                  : _createCommentVNode("", true),
                (_ctx.isAdmin && store.payOutRateSource)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_18, "out: " + _toDisplayString(_ctx.helper.trans(`rate_sources.${store.payOutRateSource}`)), 1))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isAdmin || _ctx.isMerchant || _ctx.isOperator)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _withDirectives((_openBlock(), _createElementBlock("button", {
                      type: "button",
                      onClick: ($event: any) => (_ctx.showMerchantStoreEditModal(store)),
                      title: _ctx.helper.trans('button.edit'),
                      class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                    }, _cache[19] || (_cache[19] = [
                      _createElementVNode("i", { class: "fa fa-pencil" }, null, -1)
                    ]), 8, _hoisted_20)), [
                      [
                        _directive_b_tooltip,
                        void 0,
                        void 0,
                        { hover: true }
                      ]
                    ]),
                    (_ctx.isAdmin)
                      ? _withDirectives((_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          onClick: ($event: any) => (_ctx.deleteMerchantStore(store)),
                          title: _ctx.helper.trans('button.delete'),
                          class: "btn btn-sm btn-outline-danger text-nowrap text-capitalize"
                        }, _cache[20] || (_cache[20] = [
                          _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                        ]), 8, _hoisted_21)), [
                          [
                            _directive_b_tooltip,
                            void 0,
                            void 0,
                            { hover: true }
                          ]
                        ])
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.helper.trans("labels.api_key")), 1),
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control invoice-input font-monospace",
                    value: store.apiKey,
                    readonly: ""
                  }, null, 8, _hoisted_25),
                  _createVNode(_component_copy_button, {
                    class: "btn btn-copy",
                    value: store.apiKey
                  }, null, 8, ["value"])
                ])
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(store.accounts, (storeAccount) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_AccountWidget, {
                    "show-id": "",
                    "show-icon": "",
                    "hide-insurance": "",
                    account: storeAccount.account
                  }, null, 8, ["account"]),
                  _createElementVNode("div", _hoisted_28, [
                    (_ctx.isMerchant || (_ctx.isMerchantOperator && storeAccount.account.withdrawalWhitelistsEnabled))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _withModifiers(($event: any) => (_ctx.withdrawAccount = storeAccount.account), ["prevent"]),
                            class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                          }, [
                            _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fa-solid fa-upload" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans("button.withdraw")), 1)
                          ], 8, _hoisted_30),
                          (!_ctx.isMerchantOperator)
                            ? (_openBlock(), _createElementBlock("button", _hoisted_31, _cache[22] || (_cache[22] = [
                                _createElementVNode("span", { class: "visually-hidden" }, null, -1)
                              ])))
                            : _createCommentVNode("", true),
                          (!_ctx.isMerchantOperator)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_32, [
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item text-capitalize-first",
                                    href: "#",
                                    onClick: _withModifiers(($event: any) => {_ctx.withdrawalWhitelistModal?.show(storeAccount.account);}, ["prevent"])
                                  }, _toDisplayString(_ctx.helper.trans('labels.edit_whitelist')), 9, _hoisted_33)
                                ]),
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item text-capitalize-first",
                                    href: "#",
                                    onClick: _withModifiers(($event: any) => (_ctx.autoWithdrawalSettingsModal?.show(storeAccount.account)), ["prevent"])
                                  }, _toDisplayString(_ctx.helper.trans('labels.edit_auto_withdrawal')), 9, _hoisted_34)
                                ]),
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item text-capitalize-first",
                                    href: "#",
                                    onClick: _withModifiers(($event: any) => (_ctx.autoTransferSettingsModal?.show(storeAccount.account)), ["prevent"])
                                  }, _toDisplayString(_ctx.helper.trans("labels.auto_transfer_settings")), 9, _hoisted_35)
                                ]),
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item text-capitalize-first",
                                    href: "#",
                                    onClick: _withModifiers(($event: any) => (_ctx.withdrawMerchantTransfer?.show(storeAccount.account)), ["prevent"])
                                  }, _toDisplayString(_ctx.helper.trans("button.transfer")), 9, _hoisted_36)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.isMerchantOperator)
                            ? (_openBlock(), _createElementBlock("button", _hoisted_37, _cache[23] || (_cache[23] = [
                                _createElementVNode("span", { class: "visually-hidden" }, null, -1)
                              ])))
                            : _createCommentVNode("", true),
                          (_ctx.isMerchantOperator)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_38, [
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item text-capitalize-first",
                                    href: "#",
                                    onClick: _withModifiers(($event: any) => {_ctx.withdrawalWhitelistModal?.show(storeAccount.account);}, ["prevent"])
                                  }, _toDisplayString(_ctx.helper.trans('labels.show_whitelist')), 9, _hoisted_39)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isMerchantOperator)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _withModifiers(($event: any) => (_ctx.withdrawMerchantTransfer?.show(storeAccount.account)), ["prevent"]),
                            class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                          }, [
                            _cache[24] || (_cache[24] = _createElementVNode("i", { class: "fa-solid fa-upload" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans("button.transfer")), 1)
                          ], 8, _hoisted_41)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (_ctx.accountWalletModal?.show(storeAccount.account)), ["prevent"]),
                      type: "button",
                      class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                    }, [
                      _cache[25] || (_cache[25] = _createElementVNode("i", { class: "fa-solid fa-download" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans("button.deposit")), 1)
                    ], 8, _hoisted_42),
                    (_ctx.canBalanceCorrection)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          onClick: _withModifiers(($event: any) => (_ctx.openBalanceCorrection(storeAccount, store)), ["prevent"]),
                          type: "button",
                          class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                        }, [
                          _cache[26] || (_cache[26] = _createElementVNode("i", { class: "fa fa-calculator" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.helper.trans("button.balance_correction")), 1)
                        ], 8, _hoisted_43))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  (storeAccount.account.isAutoWithdrawalEnabled &&  storeAccount.account.withdrawalWhitelistsEnabled)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_45, _toDisplayString(_ctx.helper.trans('labels.auto_withdrawal_enabled', {
            address: storeAccount.account.autoWithdrawalAddress,
            sum: storeAccount.account.autoWithdrawalMinSum
                ? _ctx.numberFormatter.formatMoney(storeAccount.account.autoWithdrawalMinSum, 0)
                : ''
          })), 1))
                    : _createCommentVNode("", true),
                  (storeAccount.account.isAutoTransferEnabled)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_46, _toDisplayString(_ctx.helper.trans('labels.auto_transfer_enabled', {
            sum: storeAccount.account.autoTransferMinSum
                ? _ctx.numberFormatter.formatMoney(storeAccount.account.autoTransferMinSum, 0)
                : '',
            store: _ctx.getTargetStoreName(storeAccount.account.autoTransferTargetAccountId)
          })), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 256)),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize-first",
                onClick: ($event: any) => (_ctx.selectStore(store, {name: 'accountOperations', query: {storeId: store.id}}))
              }, _toDisplayString(_ctx.helper.trans("menu.items.accountOperations")), 9, _hoisted_48),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize",
                onClick: ($event: any) => (_ctx.selectStore(store, {name: 'invoices', query: {storeId: store.id}}))
              }, _toDisplayString(_ctx.helper.trans("menu.items.invoices")), 9, _hoisted_49)
            ])
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showMerchantStoreEditModal({})), ["prevent"])),
          style: {"cursor":"pointer"},
          class: "card card-body me-2 ms-2 text-center d-flex justify-content-center align-items-center store-create-button"
        }, _cache[27] || (_cache[27] = [
          _createElementVNode("i", {
            style: {"font-size":"150px"},
            class: "fa fa-plus"
          }, null, -1)
        ]))
      ]),
      _createVNode(_component_b_modal, {
        "dialog-class": "modal-lg",
        title: _ctx.merchantStoreModalTitle,
        modelValue: _ctx.merchantStoreModal,
        "body-class": "p-0",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.merchantStoreModal = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_MerchantStoreForm, {
            ref: "merchantForm",
            onOpenSettingsHistory: _ctx.showStoreHistoryFromForm,
            onOpenCrossBorderRates: _ctx.showCrossBorderRates,
            onOpenReferralSettings: _ctx.showReferralFees,
            onSave: _ctx.saveMerchantStore
          }, null, 8, ["onOpenSettingsHistory", "onOpenCrossBorderRates", "onOpenReferralSettings", "onSave"])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.merchantStoreModal = false)),
            class: "btn btn-outline-secondary btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
          _createVNode(_component_LoaderWrapper, {
            ref: "loaderCreateFrom",
            zoom: 0.5
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveMerchantStore())),
                class: "btn btn-outline-primary btn-sm text-capitalize-first"
              }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      }, 8, ["title", "modelValue"]),
      _createVNode(_component_SettingsHistoryModal, {
        ref: "storeHistoryModal",
        "entity-type": "store"
      }, null, 512),
      _createVNode(_component_CrossBorderRatesModal, {
        ref: "crossBorderRatesModal",
        onApply: _ctx.applyCrossBorderRates
      }, null, 8, ["onApply"]),
      _createVNode(_component_ReferralStoreFeesModal, {
        ref: "referralFeesModal",
        onApply: _ctx.applyReferralFees
      }, null, 8, ["onApply"]),
      _createVNode(_component_b_modal, {
        title: _ctx.helper.trans('labels.withdrawal'),
        modelValue: _ctx.withdrawAccount !== null,
        "header-class": "text-capitalize",
        "body-class": "pt-0",
        "footer-class": "d-flex justify-content-between",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ($event === false && (_ctx.withdrawAccount = null)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_WithdrawalForm, {
            ref: "withdrawalForm",
            account: _ctx.withdrawAccount
          }, null, 8, ["account"])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.withdrawAccount = null)),
            class: "btn btn-outline-dark btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans("button.cancel")), 1),
          _createVNode(_component_LoaderWrapper, {
            ref: "loaderWithdrawalForm",
            zoom: 0.5
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.createWithdraw())),
                class: "btn btn-outline-primary btn-sm text-capitalize-first"
              }, _toDisplayString(_ctx.helper.trans("button.withdraw")), 1)
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      }, 8, ["title", "modelValue"]),
      _createVNode(_component_AccountWalletModal, { ref: "accountWalletModal" }, null, 512),
      _createVNode(_component_ConfirmModal, { ref: "confirmModal" }, null, 512),
      _createVNode(_component_WithdrawalWhitelistModal, {
        ref: "withdrawalWhitelistModal",
        onUpdated: _cache[7] || (_cache[7] = ($event: any) => (_ctx.update()))
      }, null, 512),
      _createVNode(_component_AutoWithdrawalSettingsModal, {
        "onAccount:updated": _cache[8] || (_cache[8] = ($event: any) => (_ctx.update())),
        ref: "autoWithdrawalSettingsModal"
      }, null, 512),
      _createVNode(_component_AutoTransferSettingsModal, {
        stores: _ctx.stores,
        "onAccount:updated": _cache[9] || (_cache[9] = ($event: any) => (_ctx.update())),
        ref: "autoTransferSettingsModal"
      }, null, 8, ["stores"]),
      _createVNode(_component_MerchantTransferModal, {
        ref: "withdrawMerchantTransfer",
        onUpdated: _cache[10] || (_cache[10] = ($event: any) => (_ctx.update()))
      }, null, 512),
      _createVNode(_component_BalanceCorrectionModal, {
        showModal: _ctx.balanceCorrectionModal,
        accountId: _ctx.balanceCorrectionAccount?.id,
        entityName: _ctx.balanceCorrectionStoreName,
        entityType: "store",
        "onUpdate:showModal": _cache[11] || (_cache[11] = ($event: any) => (_ctx.balanceCorrectionModal = $event)),
        onSuccess: _cache[12] || (_cache[12] = ($event: any) => (_ctx.update()))
      }, null, 8, ["showModal", "accountId", "entityName"])
    ]),
    _: 1
  }, 512))
}